import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
 theme: {
  themes: {
   light: {
    // Sartor brand palette (see DESIGN.md). `primary` is the warm ink used for
    // standard/dark buttons; `accent` is the brick-red signature CTA color.
    primary: '#1a1814',     // Sartor ink (warm near-black)
    secondary: '#756f64',   // warm grey
    accent: '#b52118',      // Sartor brand red — key CTAs, active nav
    background: '#f7f5f1',   // warm light canvas
    succes: '#6c8762',
    pills: '#efe9e0',
    error: '#c0392b',
    bars: "#f1ece3",
    filters_bg: "DFDFDF"
   },
  },
 },
});
